<template>
	<!--转换按钮-->
	<button type="button" @click="$emit('click')" class="btn" :class="classCpt">
		<i class="fa fa-random"></i>
		<slot>转换</slot>
	</button>
</template>

<script>
	export default{
		inheritAttrs: false, //根元素不继承特性
		props:['classCpt']
	}
</script>

<style scoped>
	button{ padding:3px 6px; }
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/btnConvert.vue